import dkAxios from '@/jslib/dk-axios'

export const getLogisticsList = data => dkAxios({
  url: '/v1/cms/Logistics',
  method: 'GET',
  params: data,
});

export const getLogisticsDetail = data => dkAxios({
  url: `/v1/cms/Logistics/${data}`,
  method: 'GET',
});

export const getLogisticsOrderDetail = data => dkAxios({
  url: '/v1/cms/Logistics/order',
  method: 'POST',
  data,
});

export const getLogisticsPointOrderDetail = data => dkAxios({
  url: '/v1/cms/Logistics/pointOrder',
  method: 'POST',
  data,
});


export const addLogistics = data => dkAxios({
  url: '/v1/cms/Logistics',
  method: 'POST',
  data,
});

export const updateLogistics = data => dkAxios({
  url: `/v1/cms/Logistics/${data.uuid}`,
  method: 'PUT',
  data,
});

export const editLogistics = data => dkAxios({
  url: `/v1/cms/LogisticsDetail/${data.uuid}`,
  method: 'PUT',
  data,
});


export const deleteLogistics = uuid => dkAxios({
  url: `/v1/cms/LogisticsDetail/${uuid}`,
  method: 'DELETE',
});



// WEBPACK FOOTER //
// ./src/api/logistics.js